import React from 'react'
import Image from '@boltui/image'

import * as Styled from '../../Footer.styles'

const imgPath = '//www.argos.co.uk/cdn/argos-style/v1.1.4/assets/img'

const BrandFooter = () => (
  <Styled.Brand className='xs-hidden md-block'>
    <Styled.BrandImage
      sainsburys
      data-test='footer-link-img-sainsburys'
      href='//www.sainsburys.co.uk/shop/gb/groceries'
      target='_blank'>
      <Image
        alt='Sainsburys brand logo'
        src={`${imgPath}/sainsburys.svg`}
        lazy
        lazyWrapElement={'span'}
        width={123}
        height={38}
      />
    </Styled.BrandImage>
    <Styled.BrandImage tu data-test='footer-link-img-tu' href='//tuclothing.sainsburys.co.uk/' target='_blank'>
      <Image
        alt='Tu clothing brand logo'
        src={`${imgPath}/tu.svg`}
        lazy
        lazyWrapElement={'span'}
        width={25}
        height={20}
      />
    </Styled.BrandImage>
    <Styled.BrandImage habitat data-test='footer-link-img-habitat' href='//www.habitat.co.uk/' target='_blank'>
      <Image
        alt='Habitat brand Logo'
        src={`${imgPath}/habitat.svg`}
        lazy
        lazyWrapElement={'span'}
        width={90}
        height={21}
      />
    </Styled.BrandImage>
  </Styled.Brand>
)

export default BrandFooter
